/** Soft currency + IAP product ids. Vehicle defs live in ./vehicles.ts */

export const IAP = {
  REMOVE_ADS: "com.worldvelopers.lanedash.removeads",
  STARTER_PACK: "com.worldvelopers.lanedash.starter",
  COINS_SMALL: "com.worldvelopers.lanedash.coins400",
  COINS_LARGE: "com.worldvelopers.lanedash.coins1200",
} as const;

export const STARTER_PACK_COINS = 300;
export const WELCOME_COINS = 100;
/** Survives STORAGE_KEY bumps so the launch bonus stays one-shot. */
export const WELCOME_GIFT_KEY = "lanedash.welcomeGift";

export const COIN_PACKS: Record<string, number> = {
  [IAP.COINS_SMALL]: 400,
  [IAP.COINS_LARGE]: 1200,
};

export const LANES = [-1.45, 0, 1.45] as const;
export const LANE_COUNT = 3;

/** Player Z in world space (camera looks toward -Z). */
export const PLAYER_Z = 4;

export const GAME = {
  maxContinuesPerRun: 2,
  invulnSeconds: 1.6,
  continueClearAhead: 18,
  highlightSeconds: 6,
  /** Jump tokens held during a run (pickups). */
  maxJumpsHeld: 3,
  /** Free token at run start so swipe-up is discoverable. */
  startJumps: 1,
  /** Baseline airborne duration in seconds (multiplied by vehicle jumpMult). */
  jumpDuration: 0.58,
  jumpHeight: 1.45,
} as const;

/** Legacy skin prices used only to refund players migrating from v2. */
export const LEGACY_SKIN_PRICES: Record<string, number> = {
  cyan: 0,
  magenta: 120,
  gold: 0,
  ghost: 200,
  ember: 180,
  mint: 150,
};

export const STORAGE_KEY = "lanedash.v5";
